<template>
  <Transition name="jp">
    <div v-if="visible" class="jp-overlay" @click.self="close">
      <div
        ref="dialog"
        class="jp-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="jp-title"
        tabindex="-1"
      >
        <button type="button" class="jp-close" aria-label="Zatvori" @click="close">
          <i class="esei icon-close" aria-hidden="true"></i>
        </button>

        <p id="jp-title" class="jp-title">Kreiraj nalog i dodaj besplatan oglas</p>

        <p class="jp-text">
          Postavi besplatan oglas kao fizičko lice ili <a class="jp-link" href="/kako-kreirati-tezga-profil" @click="leave">registruj svoju tezgu (pogledaj kako kreirati)</a> i predstavi proizvode kupcima iz cele Srbije.
        </p>
        <p class="jp-text jp-text-more">
          Sa nalogom se dopisuješ sa kupcima, pratiš oglase i dobijaš obaveštenje kad stigne poruka.
        </p>
        <p class="jp-text jp-text-short">
          Dodaj besplatan oglas ili <a class="jp-link" href="/kako-kreirati-tezga-profil" @click="leave">registruj tezgu (pogledaj kako kreirati)</a>.
        </p>

        <!-- pravi linkovi: rade i pre nego sto se ucitaju skripte; login stranica sama pokrece Google prijavu -->
        <a class="jp-btn jp-google" href="/login?social=google" @click="leave">
          <span class="jp-g" aria-hidden="true">
            <img :src="GOOGLE_G" alt="" width="18" height="18" loading="lazy" />
          </span>
          <span>Nastavi sa Google-om</span>
        </a>
        <a class="jp-btn jp-register" href="/registracija" @click="leave">Kreiraj nalog</a>
        <button type="button" class="jp-btn jp-skip" @click="close">Preskoči korak</button>

        <p class="jp-login">Već imaš nalog? <a href="/login" @click="leave">Prijavi se</a></p>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useCustomerLoginStore } from '~/stores/login/customer'

const GOOGLE_G = '/images/google-g.svg'
const SHOW_DELAY_MS = 5000
const FIRST_CLOSE_DAYS = 7     // prvo zatvaranje - ponovo posle nedelju dana
const NEXT_CLOSE_DAYS = 30     // svako sledece - posle 30 dana
const STORAGE_KEY = 'join_prompt'

const login = useCustomerLoginStore()
const route = useRoute()

// da se ne pojavi istovremeno sa karticom za obavestenja (components/push/PushPrompt.vue)
const pushOpen = useState('push_prompt_open', () => false)
const joinOpen = useState('join_prompt_open', () => false)

const visible = ref(false)
const dialog = ref(null)

let timer = null
let unmounted = false

// nema smisla na stranicama za prijavu i registraciju i u profilu
const blockedPage = () => /^\/(login|registracija|korisnicki-profil)/.test(route.path)

onMounted(() => {
  if (login.loggedIn || isHiddenByUser() || blockedPage()) return

  timer = setTimeout(waitAndShow, SHOW_DELAY_MS)
})

onBeforeUnmount(() => {
  unmounted = true
  clearTimeout(timer)
  document.removeEventListener('keydown', onKey)
  joinOpen.value = false
})

// kartica za obavestenja je otvorena: sacekamo da je korisnik zatvori
function waitAndShow() {
  if (unmounted || login.loggedIn || blockedPage()) return

  if (pushOpen.value) {
    timer = setTimeout(waitAndShow, 3000)
    return
  }

  visible.value = true
  joinOpen.value = true
  document.addEventListener('keydown', onKey)
  nextTick(() => dialog.value?.focus())
}

function onKey(event) {
  if (event.key === 'Escape') close()
}

function close() {
  const closes = readState().closes + 1
  save(closes, closes === 1 ? FIRST_CLOSE_DAYS : NEXT_CLOSE_DAYS)
  hide()
}

// kliknuo je Google ili registraciju: stranica se menja, a ako se vrati bez prijave, pitamo tek za 30 dana
function leave() {
  save(readState().closes + 1, NEXT_CLOSE_DAYS)
  hide()
}

function hide() {
  visible.value = false
  joinOpen.value = false
  document.removeEventListener('keydown', onKey)
}

function readState() {
  try {
    const state = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    return { until: Number(state.until) || 0, closes: Number(state.closes) || 0 }
  } catch (e) {
    return { until: 0, closes: 0 }
  }
}

function save(closes, days) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ closes, until: Date.now() + days * 24 * 60 * 60 * 1000 }))
  } catch (e) {
    // privatni prozor ili blokiran storage - samo zatvaramo prozor
  }
}

function isHiddenByUser() {
  return readState().until > Date.now()
}
</script>
